import React, { useEffect } from 'react';

import { LoaderSpinner } from '@vw-marketing/us-components';

import { useAuth } from '../../app/providers/AuthContext';
import { useHistory } from '../../shared/hooks/use-history';

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      history.push('/account-settings');
    }
  }, [loading, isAuthenticated, history]);

  if (loading) {
    return <LoaderSpinner />;
  }

  return <>{children}</>;
};
